// extracted by mini-css-extract-plugin
module.exports = {"portfolio-container":"Portfolio_portfolio-container__2qKks","portfolios":"Portfolio_portfolios__ZiDCO","item":"Portfolio_item__mzObE"};